module.exports = __webpack_public_path__ + "media/images/flags/at-1281f451a103684e9248610c8725fecc.svg";